import React from "react";
import { Row, Col, Card, CardBody, CardTitle } from "reactstrap";

type KpiItem = {
  title: string;
  value: React.ReactNode;
  sub?: string;
  accent?: string;
};

export default function KpiStatCards({ items }: { items: KpiItem[] }) {
  return (
    <Row className="mb-4">
      {items.map((item: KpiItem, i: number) => (
        <Col md="6" lg="3" key={i} className="mb-3 mb-lg-0">
          <Card
            className={`h-100 border-0 shadow-sm ${item.accent || ""}`}
          >
            <CardBody>
              <CardTitle tag="h6" className="text-muted text-uppercase small mb-2">
                {item.title}
              </CardTitle>
              <p className="h3 mb-0 font-weight-bold">{item.value}</p>
              {item.sub && <p className="small text-muted mb-0 mt-1">{item.sub}</p>}
            </CardBody>
          </Card>
        </Col>
      ))}
    </Row>
  );
}
